/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageRegistryDto } from '../../models/page-registry-dto';

export interface FindPage$Params {
  slug: string;
}

export function findPage(http: HttpClient, rootUrl: string, params: FindPage$Params, context?: HttpContext): Observable<StrictHttpResponse<PageRegistryDto>> {
  const rb = new RequestBuilder(rootUrl, findPage.PATH, 'get');
  if (params) {
    rb.path('slug', params.slug, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageRegistryDto>;
    })
  );
}

findPage.PATH = '/api/v1/pages/{slug}';
